export function parseRequireCameraFlag(value) {
  if (value === true || value === 1) return true;
  const s = String(value ?? "").trim().toLowerCase();
  return s === "1" || s === "true" || s === "yes";
}

export function localTracksHaveCamera(tracks) {
  return (Array.isArray(tracks) ? tracks : []).some((track) => {
    if (!track || track.kind !== "video") return false;
    const media = track.mediaStreamTrack;
    if (media && media.readyState === "ended") return false;
    return true;
  });
}

/** Tracks de câmera (não tela). disable() não solta o hardware — precisa stop(). */
export function splitLocalCameraTracks(tracks, isScreenShareTrack) {
  const camera = [];
  const rest = [];
  for (const track of Array.isArray(tracks) ? tracks : []) {
    if (!track) continue;
    const isCam = track.kind === "video" && !isScreenShareTrack?.(track);
    if (isCam) camera.push(track);
    else rest.push(track);
  }
  return { camera, rest };
}

/** Tracks de microfone. disable() também não apaga o indicador do macOS. */
export function splitLocalAudioTracks(tracks) {
  const audio = [];
  const rest = [];
  for (const track of Array.isArray(tracks) ? tracks : []) {
    if (!track) continue;
    if (track.kind === "audio") audio.push(track);
    else rest.push(track);
  }
  return { audio, rest };
}

export function localTracksHaveMic(tracks) {
  return (Array.isArray(tracks) ? tracks : []).some((track) => {
    if (!track || track.kind !== "audio") return false;
    const media = track.mediaStreamTrack;
    if (media && media.readyState === "ended") return false;
    return true;
  });
}

export function cameraRequiredJoinCopy() {
  return {
    bannerTitle: "Câmera obrigatória",
    bannerBody: "Entre com a câmera ligada — depois não dá para desligar.",
    noDevice:
      "Não encontramos uma câmera neste dispositivo. Esta chamada só aceita participantes com vídeo.",
    denied:
      "Permita o uso da câmera para entrar. Esta chamada exige vídeo ligado.",
    unavailable:
      "Não foi possível ligar a câmera. Esta chamada exige vídeo — sem câmera, não é possível entrar.",
    joinBlocked:
      "Ligue a câmera para entrar. Esta chamada não aceita participação só com áudio.",
    camTitle: "Câmera obrigatória nesta chamada — não é possível desligar o vídeo.",
    previewHint: "Câmera obrigatória",
    joinButton: "Entrar com a câmera",
  };
}

export function classifyRequiredCameraError(mediaErr) {
  const name = String(mediaErr?.name || "");
  const msg = String(mediaErr?.message || "");
  const denied =
    name === "NotAllowedError" || /Permission|NotAllowed|denied/i.test(msg);
  const noDevice =
    name === "NotFoundError" ||
    name === "OverconstrainedError" ||
    /Requested device not found|NotFound|no camera|sem câmera/i.test(msg);
  const copy = cameraRequiredJoinCopy();
  if (noDevice) return { kind: "no_device", message: copy.noDevice };
  if (denied) return { kind: "denied", message: copy.denied };
  return { kind: "unavailable", message: copy.unavailable };
}
